import palette from '../../theme/palette';

export const theme = {
  active: {
    color: palette.brandOrange,
  },
  headerTitle: {
    color: palette.cardTitle,
  },
  filter: {
    color: palette.fieldHint,
  },
  tableExpand: {
    color: palette.white,
    background: palette.filterIcon,
  },
  sortableIcon: {
    // The header cell is a flex row whose info block now shrinks to its
    // content, so a column narrower than its header would otherwise take part
    // of the squeeze out of the drag handle.
    flexShrink: 0,
    width: 22,
    textAlign: 'left',
    paddingLeft: 6,
    lineHeight: '36px',
    cursor: 'all-scroll',
    color: palette.fieldHint,
    transform: 'translateY(-2px)',
  },
};
